(function(){
  if (window.__mtReveal) return; window.__mtReveal = true;
  var SEL = '.mt-reveal:not(.is-in), .vy-reveal:not(.is-in)';
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
  function scan(){
    document.querySelectorAll(SEL).forEach(function(el){
      if (!io || el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }
  scan();
  document.documentElement.classList.add('mt-js');
  document.addEventListener('shopify:section:load', scan);
})();
